<script setup>
import EmptyStateLayout from 'dashboard/components-next/EmptyStateLayout.vue';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  title: { type: String, default: '' },
  subtitle: { type: String, default: '' },
  buttonLabel: { type: String, default: '' },
});

const emit = defineEmits(['create']);
</script>

<template>
  <EmptyStateLayout :title="title" :subtitle="subtitle" :show-backdrop="false">
    <template #actions>
      <Button
        :label="buttonLabel"
        icon="i-lucide-plus"
        @click="emit('create')"
      />
    </template>
  </EmptyStateLayout>
</template>
